import { render } from "./Intake.vue?vue&type=template&id=3a853836&ts=true"
import script from "./Intake.ts?vue&type=script&lang=ts&external"
export * from "./Intake.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__